import { BlobProvider, Page, Text, Image, View, Document, Link, Font } from '@react-pdf/renderer';
import GenCatLogo from '../../../images/Logotipo_de_la_Generalitat_de_Catalunya.png';
import { useState } from 'react';
import { styles } from '../InfoPuntPDF/InfoPuntPDFElement.js';
import { ConvertDDToDMS } from '../../Utils/FormatUtils';
import { toLonLat } from 'ol/proj';
import { checkUrl } from '../../Utils/FormatUtils';
import { config } from '../../../config/Config.js';

Font.register({
  family: 'Open Sans',
  fonts: [
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf'
    },
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
      fontWeight: 600
    }
  ]
});

let trobat = false;

const date = new Date();
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();
let data = '';
if (month < 10) {
  data = `${day}-0${month}-${year}`;
} else {
  data = `${day}-${month}-${year}`;
}

const InfoPuntDoc = ({ props }) => (
  <Document style={styles.doc}>
    <Page style={styles.mapPage} size="A4">
      <View style={styles.header} fixed>
        <Image src={GenCatLogo} style={styles.gencatLogo} />
        <Text style={styles.dataText}>{data}</Text>
      </View>
      <View style={styles.infoBody}>
        <Text style={styles.infoBodyText}>
          <Text style={styles.bold}>ETRS89 - UTM31N </Text>
          {props.coords === null ? '' : props.coords[0].toFixed(2)}, {props.coords === null ? '' : props.coords[1].toFixed(2)} m
        </Text>
        <Text style={styles.infoBodyText}>
          <Text style={styles.bold}>Geogràfiques (lat, long): </Text> {props.coords === null ? '' : toLonLat(props.coords, config.EPSG)[1].toFixed(6)}{' '}
          {props.coords === null ? '' : toLonLat(props.coords, config.EPSG)[0].toFixed(6)}{' '}
        </Text>
        {props.municipi && props.alçada !== '-9999.00' && props.alçada !== '-8888.00' && (
          <>
            {props.alçada !== null ? (
              <Text style={styles.infoBodyText}>
                <Text style={styles.bold}>Altitud: </Text>
                {props.alçada} m{' '}
              </Text>
            ) : null}
            {props.carrer !== null ? (
              <Text style={styles.infoBodyText}>
                <Text style={styles.bold}>Carrer: </Text>
                {props.carrer}
              </Text>
            ) : null}
            {props.municipi !== null ? (
              <Text style={styles.infoBodyText}>
                <Text style={styles.bold}>Municipi: </Text>
                {props.municipi}
              </Text>
            ) : null}
          </>
        )}
      </View>

      {props.infoPuntInfo &&
        props.infoPuntInfo.map((feature, index) => {
          let layerName = feature.id_?.split('.')[0];
          let isRaster = false;
          if (feature.raster) {
            isRaster = true;
            layerName = feature.layerName;
          }
          if (layerName !== undefined && layerName !== null) {
            let nomCapa, nomPunt, layerSelected, layer;
            if (props.layersSelectedOnClick.length > 0 && !props.favFeatureInfo) {
              for (let i = 0; i < props.layersSelectedOnClick.length; ++i) {
                layerSelected = props.layersSelectedOnClick[i];
                if (layerSelected.Name === layerName || layerSelected.getName() === layerName || isRaster) {
                  nomCapa = feature.layerName || layerSelected.Name || layerSelected.getTitle();
                  nomPunt = layerSelected.Tooltip || layerSelected.getExtension().ToolTip;
                  layer = layerSelected;
                }
              }
            } else {
              let favLayer = props.favFeatureInfo.layer;
              nomCapa = favLayer.Name || favLayer.getTitle();
              nomPunt = favLayer.Tooltip || favLayer.getExtension().ToolTip;
              layer = favLayer;
            }
            return (
              <View style={styles.capaWrap} wrap={false}>
                <View>
                  <View id={`point-info-card-header-${props.id}`}>
                    <View>
                      <Text style={styles.capaTitle}>{nomCapa}</Text>
                      <View>
                        <Text style={styles.capaSubTitle}>
                          {Object.entries(feature.values_).map(([key, value]) => {
                            if (key === nomPunt) {
                              trobat = true;
                              return value;
                            }
                          })}
                        </Text>
                        <Text style={styles.bold}>{!trobat && nomPunt}</Text>
                      </View>
                    </View>
                  </View>
                  <View>
                    <View>
                      <View>
                        {Object.entries(feature.values_).map(([key, value]) => {
                          let properties = layer.getProperties();
                          let property = properties.find((property) => property.name === key);
                          if (
                            (isRaster || property !== undefined) &&
                            key !== 'bbox' &&
                            key !== 'geometry' &&
                            value !== undefined &&
                            value !== '' &&
                            value !== null
                          ) {
                            return (
                              <View style={styles.values}>
                                <Text style={styles.bold}>
                                  {isRaster ? key + ': ' : property.alias + ': '}
                                  <Text style={styles.descripcion}>{value}</Text>
                                </Text>
                              </View>
                            );
                          }
                        })}
                      </View>
                    </View>
                  </View>
                </View>
              </View>
            );
          }
        })}
    </Page>
  </Document>
);

const InfoPuntPDF = (props) => {
  const [pdfHovered, setPdfHovered] = useState(false);
  return (
    <>
      <BlobProvider document={<InfoPuntDoc props={props} />}>
        {({ url }) => (
          <a id="link" href={url} target="_blank" rel="noreferrer" className="pdf-info-punt">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              x="0px"
              y="0px"
              width="20"
              height="20"
              viewBox="0 0 512 512"
              fill={window.innerWidth > 768 ? (pdfHovered ? '#febf00' : 'white') : 'white'}
              space="preserve"
              cursor="pointer"
              onMouseEnter={() => setPdfHovered(true)}
              onMouseLeave={() => setPdfHovered(false)}>
              <path d="M451.9,243.8h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L330.9,23.8c-2.2-2.4-5.4-3.8-8.6-3.8H104.5  c-22.1,0-40,17.9-40,40v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9  c22.1,0,40-17.9,40-40v-24h4.6c22.1,0,40-17.9,40-40V284c0.1-22.1-17.7-40.1-39.8-40.2C452.1,243.8,452,243.8,451.9,243.8  L451.9,243.8z M334.2,60.8l72,72h-72V60.8z M88.5,59.8c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H88.5V59.8z   M423.3,451.8c0,8.8-7.2,16-16,16H104.5c-8.8,0-16-7.2-16-16v-24h334.9v24H423.3z M121.4,349.1v41.7H85.7V276.1h49  c12.2,0,21.5,1.4,27.8,4.2c6.4,2.8,11.4,7.1,15.1,12.8c3.7,5.8,5.6,12.2,5.6,19.4c0,10.9-3.8,19.7-11.4,26.5  c-7.6,6.7-17.8,10.1-30.5,10.1H121.4z M120.9,324.5h11.8c10.4,0,15.5-3.8,15.5-11.4c0-7.2-4.8-10.8-14.4-10.8h-12.9V324.5z   M209.2,390.8V276.1h44.3c19.3,0,33.7,5.7,43.3,17.1s14.4,24.6,14.4,39.6c0,17.1-5.1,31.1-15.4,41.8c-10.3,10.7-23.6,16.1-40,16.1  H209.2z M244.4,364.4h9.2c5.8,0,10.7-2.8,14.7-8.5c4-5.7,6-13.4,6-23.1c0-8.3-1.8-15.5-5.3-21.6c-3.6-6-8.7-9.1-15.4-9.1h-9.2V364.4  z M410.5,347.9h-37.4v42.9h-34.3V276.1h82.9v27.3h-48.6v18.6h37.4V347.9z"></path>
            </svg>
          </a>
        )}
      </BlobProvider>
    </>
  );
};
export default InfoPuntPDF;
